import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { TooltipProvider } from '@radix-ui/react-tooltip'
import './theme.css'
import App from './App.jsx'
import { ParticipantProvider } from './hooks/useParticipant.js'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <ParticipantProvider>
        <TooltipProvider delayDuration={200}>
          <App />
        </TooltipProvider>
      </ParticipantProvider>
    </BrowserRouter>
  </StrictMode>,
)
